import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CookieConsent from "./CookieConsent";

const Layout = ({ children }) => {
  const [manageCookiesSignal, setManageCookiesSignal] = useState(0);

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--charcoal)] flex flex-col">
      {/* Skip to content — visible on focus for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[var(--navy)] focus:text-white focus:rounded-[3px] focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-[var(--pharma-blue)] text-sm font-medium"
        data-testid="skip-to-content"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1">{children}</main>
      <Footer onManageCookies={() => setManageCookiesSignal((n) => n + 1)} />
      <WhatsAppFloat />
      <CookieConsent openSignal={manageCookiesSignal} />
    </div>
  );
};

export default Layout;
